export const motionDurations = {
  instant: 0.08,
  fast: 0.16,
  base: 0.22,
  medium: 0.3,
  slow: 0.45,
}

export const motionEasings = {
  standard: [0.2, 0, 0, 1],
  emphasized: [0.2, 0.8, 0.2, 1],
  exit: [0.4, 0, 1, 1],
}

export const motionTransitions = {
  page: {
    duration: motionDurations.medium,
    ease: motionEasings.standard,
  },
  card: {
    duration: motionDurations.base,
    ease: motionEasings.standard,
  },
  disclosure: {
    duration: motionDurations.medium,
    ease: motionEasings.standard,
  },
  quick: {
    duration: motionDurations.fast,
    ease: motionEasings.standard,
  },
}

export const pageTransitionVariants = {
  initial: {
    y: 12,
  },
  animate: {
    y: 0,
    transition: motionTransitions.page,
  },
  exit: {
    y: -6,
    transition: {
      duration: motionDurations.fast,
      ease: motionEasings.exit,
    },
  },
}

export const staggerContainerVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.04,
      staggerChildren: 0.05,
    },
  },
}

export const cardMotionVariants = {
  hidden: {
    opacity: 0,
    y: 18,
    scale: 0.97,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: motionTransitions.card,
  },
  hover: {
    y: -3,
    scale: 1.01,
    transition: motionTransitions.quick,
  },
  tap: {
    scale: 0.985,
    transition: {
      duration: motionDurations.instant,
    },
  },
}

export const disclosureVariants = {
  collapsed: {
    height: 0,
    opacity: 0,
    y: -4,
  },
  expanded: {
    height: 'auto',
    opacity: 1,
    y: 0,
    transition: motionTransitions.disclosure,
  },
}

export const listContainerVariants = {
  hidden: {
    opacity: 1,
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.035,
    },
  },
}

export const listItemVariants = {
  hidden: {
    opacity: 0,
    y: 8,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: motionTransitions.quick,
  },
  exit: {
    opacity: 0,
    y: -6,
    transition: {
      duration: motionDurations.fast,
      ease: motionEasings.exit,
    },
  },
}

export const fadeInVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: motionTransitions.card,
  },
  exit: {
    opacity: 0,
    transition: motionTransitions.quick,
  },
}
